import "./page-shell.css";

export function PageShell({ children, className = "" }) {
  return <div className={`page-shell${className ? ` ${className}` : ""}`}>{children}</div>;
}

export function PageHeader({ title, subtitle, eyebrow, actions, onBack, backLabel = "← Retour" }) {
  return (
    <header className="page-shell__header">
      <div className="page-shell__header-left">
        {onBack ? (
          <button type="button" className="page-shell__btn page-shell__btn--ghost" onClick={onBack}>
            {backLabel}
          </button>
        ) : null}
        <div className="page-shell__heading">
          {eyebrow ? <div className="page-shell__eyebrow">{eyebrow}</div> : null}
          <h1 className="page-shell__title">{title}</h1>
          {subtitle ? <div className="page-shell__subtitle">{subtitle}</div> : null}
        </div>
      </div>
      {actions ? <div className="page-shell__actions">{actions}</div> : null}
    </header>
  );
}

export function PageContent({ children, className = "" }) {
  return <main className={`page-shell__content${className ? ` ${className}` : ""}`}>{children}</main>;
}
